import React from "react";
import BrandHeader from "./BrandHeader";
import "../ConfirmPage.css";

interface Props {
  children: React.ReactNode;
}

export default function ConfirmShell({ children }: Props) {
  return (
    <main className="confirm-page">
      <div className="confirm-container">
        <div className="confirm-card">
          <BrandHeader />
          {children}
        </div>
      </div>
    </main>
  );
}
